module.exports = __webpack_public_path__ + "img/13-02_Analytical Problem Solving.e8788162.svg";